import { ServiceLevel } from '../types/business';
import {
  AddonID,
  ENTITLED_STRIPE_SUBSCRIPTION_STATUSES,
  RUNNING_STRIPE_SUBSCRIPTION_STATUSES,
  StripeSubscriptionStatus,
} from '../types/subscription';

export const ServiceLevel2AddOn = {
  [ServiceLevel.Premium]: AddonID.ExtensionPremium,
  [ServiceLevel.Standard]: AddonID.ExtensionStandard,
};

export const addonCodeToDisplayName = (code: string | undefined): string | null => {
  if (!code) return null;
  switch (code) {
    case 'ADDON_QR_BOARD':
      return 'Visitor QR Board';
    case 'ADDON_KIOSK':
      return 'Visitor Kiosk';
    default:
      return null;
  }
};

export class SubsHelper {
  static getSubscriptionByGroupId(subscriptions: any[], { groupId }: { groupId: string }) {
    return subscriptions.find((s) => {
      if (s.businessId) {
        return s.businessId === groupId;
      }
      const [sUserId, sGroupId] = (s.id || '').split('_');
      if (!sUserId || !sGroupId) {
        console.error('getSubscriptionByGroupId data invalid', s);
        return false;
      }
      return sGroupId === groupId;
    });
  }

  static getStatus(s: { status?: string } | null | undefined): string | undefined {
    return s?.status;
  }

  static isIncomplete(s: { status?: string } | null | undefined): boolean {
    const status = SubsHelper.getStatus(s);
    return status === StripeSubscriptionStatus.Incomplete;
  }

  /** Active, trialing, or past_due — subscription can be updated or cancelled. */
  static isManageable(s: { status?: string } | null | undefined): boolean {
    if (!s) return false;
    const status = SubsHelper.getStatus(s);
    if (!status) return false;
    if (
      status === StripeSubscriptionStatus.Active ||
      status === StripeSubscriptionStatus.Trialing ||
      status === StripeSubscriptionStatus.PastDue
    ) {
      return true;
    }
    return ['Active', 'Pending', 'PastDue'].includes(status);
  }

  /** Active or trialing — entitled to paid features and add-ons. */
  static isEntitled(s: { status?: string } | null | undefined): boolean {
    if (!s) return false;
    const status = SubsHelper.getStatus(s);
    if (!status) return false;
    if ((ENTITLED_STRIPE_SUBSCRIPTION_STATUSES as readonly string[]).includes(status)) return true;
    return ['Active', 'Pending'].includes(status);
  }

  /** Blocks creating another subscription for the same business (includes incomplete). */
  static blocksNewSubscription(s: { status?: string } | null | undefined): boolean {
    if (!s) return false;
    const status = SubsHelper.getStatus(s);
    if (!status) return false;
    if ((RUNNING_STRIPE_SUBSCRIPTION_STATUSES as readonly string[]).includes(status)) return true;
    return ['Active', 'Pending', 'PastDue'].includes(status);
  }

  /** @deprecated Prefer isManageable, isEntitled, or blocksNewSubscription for new code. */
  static isRunning(s: { status?: string } | null | undefined): boolean {
    return SubsHelper.blocksNewSubscription(s);
  }
}
